import React from 'react';
import { X } from 'lucide-react';

const getErrorType = (message) => {
  if (message.startsWith('HTTP Error')) return 'HTTP Error';
  if (message.startsWith('Network Error')) return 'Network Error';
  if (message.startsWith('XMLHttpRequest')) return 'Request Error';
  return 'Console Error';
};

const PreviewErrorOverlay = ({ error, onClose, onTryToFix }) => {
  if (!error) return null;

  return (
    <div className="absolute top-4 right-4 max-w-sm bg-semantic-error border border-semantic-error/20 rounded-lg shadow-xl z-50">
      <div className="p-4">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center space-x-2">
            <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <h3 className="text-sm font-semibold text-white">
              {getErrorType(error.message)}
            </h3>
          </div>
          <button 
            onClick={onClose} 
            className="text-white/70 hover:text-white transition-colors"
          >
            <X size={14} />
          </button>
        </div>
        <div className="preview-error-content text-xs text-white mb-3 font-mono break-words max-h-40 overflow-y-auto custom-scrollbar">
          <pre className="whitespace-pre-wrap">{error.message}</pre>
        </div>
        <button
          onClick={onTryToFix}
          className="w-full bg-white text-semantic-error px-3 py-1.5 rounded-md text-xs font-medium hover:bg-white/90 transition-colors"
        >
          Try to Fix
        </button>
      </div>
    </div>
  );
};

export default PreviewErrorOverlay; 